module.exports = fox._r("images/press/icon-blog-likes.png", __webpack_public_path__ + "_/common/images/press/icon-blog-likes.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-blog-likes.png
// module id = 380
// module chunks = 2